import React, { PureComponent } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, put } from '../../redux/modules/text';
import Image from '../../components/image/Image';
import Editor from '../../components/editor/Editor';
import * as Validations from '../../validations/validations';

const FORM_NAME = 'PartnerForm';

const Home = ({ numberOfImages = 3 }) => {
  return (
    <div className="row">

      <div className="row">
        <div className="col-xs-12">
          <Field
            validate={[Validations.required, Validations.maxMediumText]}
            name="body"
            component={Editor}/>
        </div>
      </div>

      <div className="row">
        {
          [...Array(numberOfImages)].map((v, i) => {
            return (
              <div key={i} className="col-md-4">
                <Field
                  name={`photo${i + 1}`}
                  component={Image}/>
              </div>
            );
          })
        }
      </div>

    </div>
  );
};

class PartnerForm extends PureComponent {

  handlerSubmit(values) {
    const { section, getAction, putAction, close } = this.props;
    let newData = { ...values };

    return putAction(section, newData)
      .then(() => {
        getAction(section);
        close();
      });
  }

  render() {
    const { handleSubmit, pristine, reset, submitting, numberOfImages } = this.props;
    return (
      <form
        className="planet-form planet-form__team"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>
        <Home numberOfImages={numberOfImages}/>
        <div className="clearfix"></div>
        <div className="col-lg-12 text-right form-buttons">
          <button
            disabled={pristine || submitting}
            loading={submitting} type="submit"
            className="btn btn-primary btn-xl">Save
          </button>
          <button
            disabled={pristine || submitting}
            loading={submitting} type="button" className="btn  btn-primary btn-xl"
            onClick={reset}>Clear
          </button>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      myValues: getFormValues(FORM_NAME)(state) || {},
      enableReinitialize: true,
      initialValues: props.defaultValues
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/generic-text/index.js